<template>
  <div>
    <v-row>
      <v-col cols="2">
        <v-select
          v-model="myData.status"
          :items="asg.sampleStatus"
          item-text="name"
          item-value="value"
          label="状态"
          @change="$emit('query')"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="myData.projectNo"
          label="项目编号"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="myData.contractNo"
          label="合同编号"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-btn color="primary" @click="query">查询</v-btn>
        <v-btn color="primary" @click="reset" class="ml-5">重置</v-btn>
        <v-btn
          v-if="showBatchRetriveBtn"
          color="primary"
          @click="batchRetrive"
          class="ml-5"
          >批量回收</v-btn
        >
      </v-col>
    </v-row>
    <!-- 批量申请回收 -->
    <retrieve v-model="showRetrieve" :item="retrieveParams" :sendParams="sendParams" @query="$emit('query')" />
  </div>
</template>

<script>
import { asg } from "@/plugins/chart";
import retrieve from "./retrieve.vue";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    sendParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    showBatchRetriveBtn() {
      return this.myData?.status === "0";
    },
  },
  watch: {
    data(newVal) {
      this.myData = newVal;
    },
    list: {
      handler(newVal) {
        const selectList = newVal?.filter(item => item.isChecked) ?? [];
        this.selectList.splice(0, this.selectList.length, ...selectList);
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      asg,
      myData: this.data,
      selectList: [], //当前选中数据
      showRetrieve: false, //是否展示申请回收
      retrieveParams: {}, //申请回收参数
    };
  },
  components: {
    retrieve
  },
  methods: {
    query() {
      this.$emit("query");
    },
    reset() {
      this.$emit("reset");
    },
    batchConfirm() {
      this.$emit("batchConfirm");
    },
    //批量回收
    batchRetrive() {
      if (!this.selectList.length) {
        this.$message.warn("请选择至少一条数据。");
        return;
      }
      this.retrieveParams = {
        type: 'batchRetrive',
        data: this.selectList
      }
      this.showRetrieve = true
    },
  },
};
</script>
